import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Drawer from "../../../aat/components/UI/Drawer/Drawer";
import Icon from "../Icon/Icon";
import { PrimaryButton } from "../UI/Button/Button";
import StyledDatePicker from "../UI/StyledDatePicker/StyledDatePicker";
import { format, isValid } from "../../../lib/date";
// import "../../../aat/components/Filter/_datepicker.css";
//import { Device } from "../../../components/device";

const FormWrap = styled.form`
    box-sizing: border-box;
    color: var(--form-input-color, currentColor);
    font-size: 1rem;
    .date-range__dates {
        width: 100%;
        td {
            padding: 0 1rem 1rem;
            border-bottom: 4px solid var(--color-gray-20, #ebebeb);
        }
    }
    .DayPickerRangeController-wrap {
        border: 1px solid var(--color-gray-20, #ebebeb);
        overflow: hidden;
    }
    .DayPicker {
        position: relative;
        left: -16px;
        @media only screen and (min-width: 360px) {
            left: 4px;
        }
        @media only screen and (min-width: 375px) {
            left: 11px;
        }
        @media only screen and (min-width: 411px) {
            left: 30px;
        }
        @media only screen and (min-width: 768px) {
            left: 0px;
        }
    }
`;


interface DatePickerFormProps
{
    drawer: boolean;
    startDate?: Date;
    endDate?: Date;
    closeDrawer: () => void;
    onSubmit: (startDate?: Date, endDate?: Date) => void;
    zIndex: number;
}

const DatePickerForm: React.FunctionComponent<DatePickerFormProps> = (props) =>
{
    const [startDate, setStartDate] = useState(props.startDate);
    const [endDate, setEndDate] = useState(props.endDate);
    const [isDirty, setDirty] = useState<boolean>(false);

    // Handle props change outside
    useEffect(() =>
    {
        if (props.startDate !== startDate)
        {
            setStartDate(props.startDate);
        }

        if (props.endDate !== endDate)
        {
            setEndDate(props.endDate);
        }
    }, [props.startDate, props.endDate]);

    const renderButton = () =>
    {
        if (!isDirty)
        {
            return (
                <PrimaryButton className="drawer__footer-btn" type="button" onClick={props.closeDrawer} size="small">
                    <span className="drawer__footer-icon-left">
                        <Icon name="arrow-left-line" className="w-4 h-4" />
                    </span>
                    <span>Tilbage</span>
                    <span className="drawer__footer-icon-right"></span>
                </PrimaryButton>
            );
        }
        else
        {
            return (
                <PrimaryButton className="drawer__footer-btn" type="submit" size="small">
                    Gem
                </PrimaryButton>
            );
        }
    };

    const onSubmit = (event: React.FormEvent<HTMLFormElement>) =>
    {
        event.preventDefault();
        if (isDirty)
        {
            props.onSubmit(startDate, endDate);
            setDirty(false);
        }
        props.closeDrawer();
    };

    const handleStartDateChange = (date: Date) =>
    {
        setStartDate(date);
        setDirty(true);
    };

    const handleEndDateChange = (date: Date) =>
    {
        setEndDate(date);
        setDirty(true);
    };

    return (
        <Drawer visible={props.drawer} close={props.closeDrawer} placement="right" zIndex={props.zIndex}>
            <FormWrap onSubmit={onSubmit}>
                <div className="drawer__header">
                    <span className="h5 mb-0">Dato</span>
                </div>
                <div className="drawer__main drawer__main--minus-header-footer">
                    <table className="date-range__dates">
                        <tbody>
                            <tr>
                                <td>
                                    <div className="text-black">Fra dato</div>
                                    <div className="text-gray-30">{isValid(startDate) ? format(startDate as Date, "dd MMM yyyy") : null}</div>
                                </td>
                                <td>
                                    <div className="text-black">Fra dato</div>
                                    <div className="text-gray-30">{isValid(endDate) ? format(endDate as Date, "dd MMM yyyy") : null}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="DayPickerRangeController-wrap">
                        <StyledDatePicker
                            selectedDate={startDate}
                            handleDateChange={handleStartDateChange}
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            isClearable
                            inline
                        />
                        <StyledDatePicker
                            selectedDate={endDate}
                            handleDateChange={handleEndDateChange}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            isClearable
                            inline
                        />
                    </div>
                </div>
                <div className="drawer__footer">
                    {renderButton()}
                </div>
            </FormWrap>
        </Drawer>
    );
};

export default DatePickerForm;
